//---------------------------------------------------------------------------------------------------
//  ?                              TRADING DATA LAYOUT
//  @author         :  DeeTrade Team
//  @createdOn      :  04/10/2026
//  @description    :  React Router v6 layout wrapper — provides TradingDataContext to nested routes
//---------------------------------------------------------------------------------------------------

import React from 'react';
import { Outlet } from 'react-router-dom';
import { TradingDataProvider } from './TradingDataContext';

// --> Layout route that wraps child routes with the TradingDataProvider
function TradingDataLayout() {
  return (
    <TradingDataProvider>
      <Outlet />
    </TradingDataProvider>
  );
}

export default TradingDataLayout;
